<template>
  <div
    class="sticky top-[calc(var(--schedule-sticky-offset,0px)_-_var(--sera-main-padding))] z-20 -mx-[var(--sera-main-padding)] -mt-[var(--sera-main-padding)] flex items-center gap-2 border-b border-solid border-gray-200 bg-white px-4 py-2"
    data-cy="technician-control-row"
  >
    <button
      type="button"
      class="flex min-w-0 flex-1 items-center gap-3 text-left"
      @click="emit('select')"
    >
      <slot name="avatar"></slot>
      <span class="min-w-0 flex-1">
        <span class="block truncate text-base font-semibold text-gray-900">
          {{ title }}
        </span>
        <span class="block truncate text-xs text-gray-500">{{ summary }}</span>
      </span>
    </button>
    <button
      type="button"
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-solid border-gray-200 text-gray-500"
      aria-label="Scheduler settings"
      data-cy="scheduler-settings"
      @click="emit('settings')"
    >
      <i class="fa-regular fa-gear" />
    </button>
  </div>
</template>

<script setup lang="ts">
// The phone scheduler's control row: who is being scheduled and how much work
// that schedule holds, with the two entry points the row offers. The content
// components (Unassigned, one technician) fill the avatar slot and the copy;
// this shell owns the sticky bar, the tap targets and the events.
//
// All three offsets cancel one page padding (`.layout-1` carries
// `--sera-main-padding` on every side) so the bar meets the app header with no
// seam: the negative margins lift it out of that padding where it sits, and the
// negative sticky top moves the pin there too. A plain `top-0` pins at the
// scroll container's content edge instead, one padding below the header, and
// the calendar paints its hours up behind the header through the gap that
// leaves. Same trick as Seranova's ActionBar at the bottom edge.
//
// The sticky top also takes `--schedule-sticky-offset` from an ancestor: a
// band pinned above this bar (the mobile-view banner) sets it to its own
// height, so the bar pins beneath the band rather than under it. Unset, it is
// 0px and the bar pins at the header as before.
defineProps<{ title: string; summary: string }>();

const emit = defineEmits<{
  (e: "select"): void;
  (e: "settings"): void;
}>();
</script>
